const allPrefix = [{text:'All',value:'All'},
                   {text:'None',value:'None'},{divider:true}];

function spiritsExciseTypes(allAndNone=false) {
  const types =  [{header:'Additions to bulk spirits inventory'},
                  {text:'Spirits produced',value:'SpiritsAdditionSpiritsProduced'},
                  {text:'Received from licensees',value:'SpiritsAdditionReceivedFromLicensees'},
                  {text:'Imported',value:'SpiritsAdditionImported'},
                  {text:'Packaged spirits returned to bulk',value:'SpiritsAdditionPackagedSpiritsReturnedToBulk'},
                  {divider:true},
                  {header:'Reductions to bulk spirits inventory'},
                  {text:'Removed to spirits licensee',value:'SpiritsReductionRemovedToSpiritsLicensee'},
                  {text:'Removed to licensed users domestic',value:'SpiritsReductionRemovedToLicensedUsersDomestic'},
                  {text:'Removed to licensed users imported',value:'SpiritsReductionRemovedToLicensedUsersImported'},
                  {text:'Denatured spirits fuel DA-2F',value:'SpiritsReductionDenaturedSpiritsFuelDA2F'},
                  {text:'Denatured spirits fuel DA-2G',value:'SpiritsReductionDenaturedSpiritsFuelDA2G'},
                  {text:'Denatured spirits other',value:'SpiritsReductionDenaturedSpiritsOther'},
                  {text:'Specially denatured spirits',value:'SpiritsReductionSpeciallyDenaturedSpirits'},
                  {text:'Exported',value:'SpiritsReductionExported'},
                  {text:'To packaging non-duty paid > 7%',value:'SpiritsReductionToPackagingNonDutyPaidGT7'},
                  {text:'To packaging non-duty paid <= 7%',value:'SpiritsReductionToPackagingNonDutyPaidLE7'},
                  {text:'To packaging non-duty paid marked special containers',value:'SpiritsReductionToPackagingNonDutyPaidMarkedSpecialContainers'},
                  {text:'To packaging duty-paid',value:'SpiritsReductionToPackagingDutyPaid'},
                  {text:'Bulk spirits returned to spirit production',value:'SpiritsReductionBulkSpiritsReturnedToSpiritProduction'},
                  {text:'Other non-duty paid',value:'SpiritsReductionOtherNonDutyPaid'},
                  {text:'Other duty-paid',value:'SpiritsReductionOtherDutyPaid'},
                  {divider:true},
                  {text:'Inventory Adjustment',value:'SpiritsInventoryAdjustment'}];
  return allAndNone ? allPrefix.concat(types) : types;
}

function productExciseTypes(allAndNone=false) {
  const types =   [{header:'Additions to inventory'},
                  {text:'Domestic non-duty-paid packaged',value:'ProductAdditionDomestic'},
                  {text:'Imported non-duty-paid packaged	',value:'ProductAdditionImported'},
                  {text:'Returned from duty-paid sources',value:'ProductAdditionReturnedDutyPaid'},
                  {text:'Returned from non-duty-paid sources',value:'ProductAdditionReturnedNonDutyPaid'},
                  {divider:true},
                  {header:'Reductions to inventory: non-duty-paid'},
                  {text:'Removed for delivery to registered users',value:'ProductReductionToRegisteredUsers'},
                  {text:'Removed for delivery to accredited representatives',value:'ProductReductionToAccreditedReps'},
                  {text:'Removed for delivery to duty free shops',value:'ProductReductionToDutyFree'},
                  {text:'Removed for delivery as ships stores',value:'ProductReductionToShipsStores'},
                  {text:'Removed for delivery to licensed users domestic',value:'ProductReductionToLicensedUserDomestic'},
                  {text:'Removed for delivery to licensed users imported',value:'ProductReductionToLicensedUserImported'},
                  {text:'Removed for delivery to other excise warehouses',value:'ProductReductionToOtherExciseWarehouse'},
                  {text:'Exported spirits',value:'ProductReductionExported'},
                  {text:'Returned to Spirits Licensee',value:'ProductReductionReturnToSpiritsLicensee'},
                  {text:'Breakage	',value:'ProductReductionBreakage'},
                  {text:'Spirits removed for other purposes (specify)',value:'ProductReductionForOtherPurpose'},
                  {header:'Reductions to inventory: duty-paid'},
                  {text:'Packaged (excluding marked special containers)',value:'ProductReductionDutyPaidPackaged'},
                  {text:'Packaged in marked special containers	',value:'ProductReductionDutyPaidMSC'},
                  {text:'Spirits removed for other purposes (specify)',value:'ProductReductionDutyPaidOtherPurposes'},
                  {divider:true},
                  {text:'Inventory Adjustment',value:'ProductInventoryAdjustment'}];
  return allAndNone ? allPrefix.concat(types) : types;
}

function wineExciseTypes(allAndNone=false) {
  const types =  [{header:'Additions to inventory'},
                  {text:'Domestic wine',value:'UserWineAdditionDomestic'},
                  {text:'Imported wine',value:'UserWineAdditionImported'},
                  {divider:true},
                  {header:'Reductions to inventory'},
                  {text:'Used in an approved formulation: Restricted formulation',value:'UserWineReductionFormulationRestricted'},
                  {text:'Used in an approved formulation: Other',value:'UserWineReductionFormulationOther'},
                  {text:'Used to produce vinegar',value:'UserWineReductionVinegar'},
                  {text:'Blended with spirits to produce spirits',value:'UserWineReductionBlendedWithSpirits'},
                  {text:'Returned to wine licensee or excise warehouse licensee',value:'UserWineReductionReturnedToLicensee'},
                  {text:'Exported wine',value:'UserWineReductionExported'},
                  {text:'Used in approved processes',value:'UserWineReductionApprovedProcess'},
                  {text:'Removed for other purposes (specify)',value:'UserWineReductionOther'},
                  {divider:true},
                  {text:'Inventory Adjustment',value:'UserWineInventoryAdjustment'}];
  return allAndNone ? allPrefix.concat(types) : types;
}

export default {spiritsExciseTypes,wineExciseTypes,productExciseTypes};
